<template>
  <div class="sign_up" style="background-color: #fff" ref="form">
    <div class="title" style="padding: 15px 0px 5px 0px" xs12>
      <div style="width: 100%; height: 52px; text-align: center">
        <img style="width: 50px; height: 50px" @click="addClickTimes()" src="imgs/svg/my/logo.png" />
      </div>
      <div style="text-align: center; margin-top: 5px">
        <span class="login_span">{{ displayName }}</span>
      </div>
    </div>
    <v-text-field name="phoneNumber" style="width: 85%; margin-left: 7.5%; margin-top: 20px" flat :label="$t('手机号')"
      single-line validate-on-blur :rules="[rules.required, rules.phoneMatch]" v-model="phoneNumber" :append-icon="phoneNumberHistory.number.length != 0 ? 'arrow_drop_down' : ''
        " @click:append="showHistory()" ref="phoneNumber" tabindex="1" required clearable @keydown="focus2password()"
      pattern="[0-9]*" type="number"></v-text-field>

    <div class="phone-number-history theme--light" v-show="phoneNumberHistory.visible">
      <div class="phone-number" v-for="(number, index) in phoneNumberHistory.number" :key="index"
        @click="(e) => selectNumber(e, number)">
        <span>{{ number }}</span>
        <div class="clear-icon">
          <v-icon @click="(e) => clearHistoryNumber(e, number)">clear</v-icon>
        </div>
      </div>
    </div>

    <div>
      <v-text-field ref="regcode" name="regcode" style="width: 85%; margin-left: 7.5%" flat :label="$t('验证码')"
        single-line validate-on-blur v-model="regcode" :rules="[rules.required]" type="number" required clearable
        tabindex="2" @focus="go2login()" @keydown="focus2login()" pattern="[0-9]*"></v-text-field>
      <v-btn depressed class="get_regcode" :disabled="vcode_disabled" @click="get_vcode" v-html="get_regcode"></v-btn>
      <v-checkbox :label="$t('记住账号')" class="is_remember" color="blue" v-model="isRemember"></v-checkbox>
      <p class="forgot" @click="Change2Pwd">{{ $t('使用密码登录') }}</p>
    </div>

    <v-flex style="width: 90%; margin-left: 5%">
      <v-btn :loading="loading3" :disabled="loading3" tabindex="3" class="login" color="primary" @click="Login">
        {{ $t('登录') }}
      </v-btn>
    </v-flex>
    <div class="licence-wrap">
      <v-checkbox :label="$t('我已阅读并同意')" color="blue" v-model="__isAgreeLicence"></v-checkbox>
      <span class="licence-link" @click="showRules()">{{ $t('《软件许可与服务协议》') }}</span>
    </div>
  </div>
</template>

<script>
// libs
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import axios from 'axios'
import msgbus from '../msgBus'
import operations from '../operations'
import funcListConfig from '../funcListConfig'
import dbHelper from '../util/db'
import debugHelper from '../util/debug'
import tools from '../util/tools'
import { URLS } from '../util/urls'
import isTest from '../util/urltest'
import i18n from '../lang/index'


export default {
  name: 'iDS-RegLogin',
  data: function () {
    return {
      isAgreeLicence: false, // 标识是否同意服务协议
      phoneNumber: '',
      isRemember: true,
      regcode: '',
      licence: '',
      vcode_disabled: false,
      vcode: this.$t('获取验证码'),
      formHasErrors: false,
      loading3: false,
      rules: {
        required: (v) => !!v || this.$t('该项不能为空'),
        phoneMatch: (phone) =>
          /^1\d{10}$/.test(phone) || this.$t('手机号码有误，请重填'),
        min: (v) => (!!v && v.length >= 6) || this.$t('密码长度要大于等于6'),
      },
      phoneNumberHistory: {
        visible: false,
        number: [],
      },
      isTest: isTest,
    }
  },

  computed: {
    ...mapGetters('app', ['displayName']),
    form() {
      return {
        phoneNumber: this.phoneNumber,
        regcode: this.regcode,
      }
    },
    get_regcode() {
      return this.vcode
    },
    __isAgreeLicence: {
      get() {
        return this.isAgreeLicence
      },
      set(value) {
        this.isAgreeLicence = value
        dbHelper.set('isAgreeLicence', this.isAgreeLicence)
      },
    },
  },

  methods: {
    showRules() {
      msgbus.vm.setPhoneNumber({ value: this.phoneNumber })
      msgbus.vm.setRegcode({ value: this.regcode })
      this.$router.push({ name: 'licence' })
    },
    hideHistory() {
      this.phoneNumberHistory.visible = false
    },
    getHistory() {
      var history = dbHelper.get('phoneNumberHistory')
      if (history != null) {
        this.phoneNumberHistory = JSON.parse(history)
        this.phoneNumberHistory.visible = false
      }
    },
    saveHistory() {
      debugHelper.log(this.phoneNumberHistory)
      dbHelper.set(
        'phoneNumberHistory',
        JSON.stringify(this.phoneNumberHistory)
      )
    },
    clearHistoryNumber(e, number) {
      e.stopPropagation()
      var index = this.phoneNumberHistory.number.indexOf(number)
      this.phoneNumberHistory.number.splice(index, 1)
      this.saveHistory()
    },
    selectNumber(e, number) {
      e.stopPropagation()
      this.phoneNumber = number
      this.phoneNumberHistory.visible = !this.phoneNumberHistory.visible
      document.getElementsByTagName('input')[0].focus()
    },
    showHistory() {
      if (this.phoneNumberHistory.number.length != 0) {
        this.phoneNumberHistory.visible = !this.phoneNumberHistory.visible
      } else {
        this.phoneNumberHistory.visible = false
      }
    },
    mSetParams(funcList) {
      var func = funcList[0]
      switch (func.id) {
        case operations.eCreateBottomsByRoles:
          func.params.roles = msgbus.vm.getUserRoles()
          break
      }
      return funcList
    },
    mGetResult(funcList) {
      var func = funcList[0]
      return funcList
    },
    focus2password() {
      this.hideHistory()
      if (event.keyCode == 13) {
        const pwdIndex = 1
        document.getElementsByTagName('input')[pwdIndex].focus()
      }
    },
    focus2login() {
      this.hideHistory()
      if (event.keyCode == 13) {
        this.Login()
      }
    },

    go2login() {
      setTimeout(function () {
        let btnLogin = document.getElementsByClassName('login')[0]
        if (btnLogin) {
          btnLogin.scrollIntoViewIfNeeded(false)
        }
      }, 500)
    },

    go2body() {
      var regcode = document.getElementsByName('regcode')[0]
      regcode.blur()
      setTimeout(function () {
        document.getElementsByTagName('body')[0].scrollTop = 0
      }, 500)
    },

    Login() {
      var formHasErrors = false
      //检查表单
      Object.keys(this.form).forEach((f) => {
        if (!this.$refs[f].validate(true)) {
          formHasErrors = true
        }
      })
      //有错返回
      if (formHasErrors) {
        return
      }

      if (!this.isAgreeLicence) {
        msgbus.vm.setSnackBar({
          value: {
            color: 'error',
            text: this.$t('请阅读并同意服务协议'),
            visible: true,
          },
        })
        return
      }

      //记住账号
      if (this.isRemember) {
        dbHelper.set('phoneNumber', this.phoneNumber)
        if (
          this.phoneNumberHistory.number.filter(
            (number) => number == this.phoneNumber
          ).length == 0
        ) {
          this.phoneNumberHistory.number.push(this.phoneNumber)
        }
        this.saveHistory()
      } else {
        dbHelper.remove('phoneNumber')
        let index = this.phoneNumberHistory.number.indexOf(this.phoneNumber)
        if (index != -1) {
          this.phoneNumberHistory.number.splice(index, 1)
          this.saveHistory()
        }
      }
      this.loader = 'loading3'
      this.go2body()
      // 登录
      msgbus.vm
        .fetchAuthToken({
          data: {
            mobileNo: this.phoneNumber,
            password: '',
            vcode: this.regcode,
          },
          vm: msgbus.vm,
        })
        .then(
          () => {
            msgbus.vm.setIsPwd({ value: false })
            msgbus.vm.setRegcode({ value: this.regcode })
            this.loading3 = false

            // 初始化系统
            tools.startFuncList(
              msgbus,
              this,
              funcListConfig.common.initAfterLogin
            )
          },
          () => {
            this.loading3 = false
            return
          }
        )
    },
    Change2Pwd() {
      if (this.phoneNumber) {
        msgbus.vm.setPhoneNumber({ value: this.phoneNumber })
      }
      this.$router.replace({ name: 'pwdlogin' })
    },
    get_vcode() {
      var formHasErrors = false

      //检查表单
      formHasErrors = !this.$refs['phoneNumber'].validate(true)

      //有错返回
      if (formHasErrors) {
        msgbus.vm.setSnackBar({
          value: {
            color: 'error',
            text: this.$t('手机号码有误'),
            visible: true,
          },
        })
        return
      }

      // 设置验证码获取等待时间 60秒过后button上的文字初始化,计时器初始化;
      msgbus.vm.setRegcodeWaitingTime({ value: 60 })
      // 设置等待验证码
      this.setRegcodeWaiting()

      // 获取验证码
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: URLS.EDS_VCODE_URL,
          data: {
            mobileNo: this.phoneNumber,
          },
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((resp) => {
            this.vcode_disabled = true
            this.vcode = this.$t('验证码已发送')
            msgbus.vm.setRegcodeWaitingTime({ value: 0 })
            resolve()
          })
          .catch((err) => {
            debugHelper.log(err)
            err.type = 'error'
            err.prefix = 'vcode:'
            tools.showTips(msgbus.vm, err)
            msgbus.vm.setRegcodeWaitingTime({ value: 0 })
            return
          })
      })
    },
    // 设置验证码获取等待时间
    setRegcodeWaiting() {
      let regcodeWaitingTime = msgbus.vm.getRegcodeWaitingTime()
      if (regcodeWaitingTime == 0) {
        this.vcode_disabled = false
        this.vcode = this.$t('获取验证码')
        msgbus.vm.setRegcodeWaitingTime({ value: 60 }) //60秒过后button上的文字初始化,计时器初始化;
        return
      } else {
        this.vcode_disabled = true
        this.vcode = this.$t('{number}秒后重新发送', { number: regcodeWaitingTime })
        msgbus.vm.setRegcodeWaitingTime({ value: regcodeWaitingTime - 1 })
      }
      var that = this
      setTimeout(function () {
        that.setRegcodeWaiting()
      }, 1000) //每1000毫秒执行一次
    },
    getLicence() {
      axios({
        method: 'get',
        url: URLS.EDS_LICENCE_URL,
        params: {
          language: i18n.locale,
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        },
      }).then((res) => {
        this.licence = res.data.content
      })
    },

    changeView() {
      msgbus.vm.setTitle('')
      msgbus.vm.setBackDisabled(true)
      msgbus.vm.setBackIcon('')
      msgbus.vm.setBottomNavVisible(false)
      msgbus.vm.setBottomBtnVisible(false)
      msgbus.vm.setMsgInputVisible({ value: false })

      if (!this.phoneNumber) {
        document.getElementsByName('phoneNumber')[0].focus()
      } else {
        document.getElementsByName('regcode')[0].focus()
      }
    },
  },
  watch: {
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
  },
  created() {
    // 若是“软件许可与服务协议”页面返回，则先判断是否有手机号/验证码的设置信息
    this.phoneNumber = msgbus.vm.getPhoneNumber()
    this.regcode = msgbus.vm.getRegcode()

    // 默认勾选记住账号
    this.isRemember = true
    // 读取许可协议标识
    this.isAgreeLicence =
      (dbHelper.get('isAgreeLicence') || 'false') !== 'false'
  },
  mounted() {
    document.body.addEventListener('click', this.hideHistory)
    this.getHistory()
    this.changeView()
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.hideHistory)
    this.saveHistory()
  },
}
</script>

<style lang="scss">
.sign_up {
  .is_remember {
    float: left;
    margin-left: 7.5%;
    margin-top: 0px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #3a3a3a;
    letter-spacing: 0;
  }

  .forgot {
    float: right;
    margin-right: 7.5%;
    margin-top: 0px;
    padding-top: 4px;
    color: blue;
    margin-bottom: 0px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #3a3a3a;
    letter-spacing: 0;
  }

  .phone-number-history {
    position: absolute;
    z-index: 1000;
    font-size: 1.3rem;
    width: 85%;
    margin-left: 7.5%;

    padding: {
      top: 0.5rem;
      bottom: 0.5rem;
    }

    border: {
      left: {
        style: solid;
        width: 2px;
        color: #dddddd;
      }

      right: {
        style: solid;
        width: 2px;
        color: #dddddd;
      }

      bottom: {
        style: solid;
        width: 2px;
        color: #dddddd;
      }
    }

    top: 213px;

    background: white;
    height: 7rem;
    overflow: auto;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

    .phone-number {
      padding: {
        left: 10px;
      }

      .clear-icon {
        float: right;
        margin-right: 10px;
      }
    }
  }

  h1:first-child {
    width: 100%;
    text-align: center;
    margin-top: -100px;
    margin-bottom: 12px;
  }

  .v-input__slot {
    margin-bottom: 0px;
    border-width: thin;
  }

  .v-text-field {
    margin-bottom: 2px;
  }

  .v-text-field__details {
    margin-top: 4px;
    margin-bottom: 4px;
  }

  button.v-btn.login {
    width: calc(100% - 16px);
  }

  .get_regcode {
    float: right;
    padding: 0 8px;
    margin-top: -56px;
    margin-right: 8%;
    width: auto !important;
    height: 25px;
    font-size: 14px;
    background: #ffffff;
    border: 1 solid rgb(48, 133, 214);
    border-radius: 2px;
    color: rgb(48, 133, 214);
  }

  .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
    background-color: #ffffff;
    border: 1px solid rgb(48, 133, 214);
  }

  .theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    background-color: #ffffff !important;
    border: 1px solid #d7d7d7 !important;
    color: #d7d7d7 !important;
  }

  .login_span {
    font-family: PingFangSC-Medium;
    font-size: 17px;
    color: #4a4a4a;
    letter-spacing: 0;
    text-align: center;
  }

  .v-label {
    font-size: 14px;
  }

  .primary {
    background-color: rgb(48, 133, 214) !important;
    border-color: rgb(48, 133, 214) !important;
  }

  input {
    margin-top: 0px !important;
    padding: 6px 0;
  }

  .licence-wrap {
    position: relative;
    margin-top: 10px;
    margin-left: 7.5%;

    & .v-input--checkbox {
      display: inline-block;
      margin-top: 0;
      vertical-align: top;

      & .v-input__slot {
        margin-bottom: 0;
      }
    }

    & .licence-link {
      display: inline-block;
      color: #1d80dd;
      font-size: 14px;
      text-align: center;
      vertical-align: top;
      padding-top: 5px;
    }
  }
}
</style>
